import { Card } from 'primereact/card';

const UnauthorizedPage = () => {
    return (
        <div className="flex justify-content-center align-items-center h-screen">
            <Card className="shadow-2 p-4 text-center" style={{ maxWidth: '400px' }}>
                <h1 className="text-red-500">Sie sind nicht berechtigt!</h1>
                <p>Sie sind nicht berechtigt auf diese Seite zuzugreifen. Loggen Sie sich neu ein oder wenden Sie sich an Ihren Ansprechpartner!</p>
                <p
                    className="text-red-600 font-bold mt-3"
                    style={{ border: '1px solid #dc3545', padding: '10px', borderRadius: '5px', backgroundColor: '#f8d7da' }}
                >
                    Falls Sie eingeloggt waren, aktualisieren Sie einfach Ihren Browser oder drücken <strong>F5</strong>
                </p>
            </Card>
        </div>
    );
};

export default UnauthorizedPage;
